import {
  KICKSTART_CC_CAPTURE_LINEAR_ID,
  TRIAL_CC_CAPTURE_LINEAR_ID,
  KICKSTART_ONBOARD_CC_CAPTURE_LINEAR_ID,
  TRIAL_ONBOARD_CC_CAPTURE_LINEAR_ID,
  MESSAGE_PAYMENT_METHOD_FAILED,
  STATUS_PAYMENT_METHOD_SUCCEEDED,
  STATUS_PAYMENT_METHOD_PROCESSING
} from '../../constants'

const VARIANT_ONBOARDING = 'onboarding'
const VARIANT_IN_APP = 'in-app'

const TRIAL_KICKSTART = 'Kickstart'
const TRIAL_PLATFORM = 'Platform'

const TRIAL_VARIANT = 'trial'

const ONBOARD_KICKSTART = `${VARIANT_ONBOARDING}${TRIAL_KICKSTART}`
const ONBOARD_PLATFORM = `${VARIANT_ONBOARDING}${TRIAL_PLATFORM}`

const TRIAL_OPTIONS = [
  {
    title: 'Platform Trial',

    description: [
      'Get step-by-step guidance and progress tracking to accomplish your goals.',
      'Plus, expert-led office hours, unlimited resources, and Andy AI assistance.'
    ].join(' '),

    value: TRIAL_PLATFORM
  },

  {
    title: 'Platform Trial + Kickstart with a Navigator',

    description: [
      'Start your trial by meeting 1:1 with a Navigator to customize your child’s Roadmap,',
      'introduce you to tools, and address your unique needs.'
    ].join(' '),

    value: TRIAL_KICKSTART
  }
]

const MESSAGE_PAYMENT_METHOD_SUCCESS = 'Success! Your subscription has been activated.'
const MESSAGE_PAYMENT_METHOD_PROCESSING = 'Processing payment details. We’ll update you soon.'
const MESSAGE_PAYMENT_METHOD_INVALID_REQUEST = 'Invalid payment request.'
const MESSAGE_PAYMENT_METHOD_ALREADY_MEMBER = 'You are already a member.'

const LINEAR_ID_MAP = {
  [TRIAL_KICKSTART]: KICKSTART_CC_CAPTURE_LINEAR_ID,
  [TRIAL_PLATFORM]: TRIAL_CC_CAPTURE_LINEAR_ID,
  [ONBOARD_KICKSTART]: KICKSTART_ONBOARD_CC_CAPTURE_LINEAR_ID,
  [ONBOARD_PLATFORM]: TRIAL_ONBOARD_CC_CAPTURE_LINEAR_ID
}

const BILLING_CYCLE_MONTHLY = 'month'
const BILLING_CYCLE_YEARLY = 'year'

const MEMBERSHIP_OPTION_PLATFORM = 'platform'
const MEMBERSHIP_OPTION_NAVIGATOR = 'navigator'

// The membership’s plans, keyed as fetchMembershipOptions keys them under basePlan.
const MEMBERSHIP_PLANS = [
  { interval: 'monthly', label: 'Monthly', suffix: '/month', billingCycle: BILLING_CYCLE_MONTHLY },
  { interval: 'annual', label: 'Annual', suffix: '/year', billingCycle: BILLING_CYCLE_YEARLY }
]

// A coupon’s validBillingPeriod when it applies to either billing cycle; any other value ties it to one cycle.
const COUPON_BILLING_PERIOD_BOTH = 'both'

// The price suffix once a coupon discounts the selected cycle, in place of its billing period.
const LABEL_DUE_TODAY = '/due today'

// The steps of a membership checkout, as tracked when a parent dismisses it.
const PAYMENT_STEP_PLAN = 'plan'
const PAYMENT_STEP_PAYMENT = 'payment'

export {
  VARIANT_ONBOARDING,
  VARIANT_IN_APP,
  TRIAL_KICKSTART,
  TRIAL_PLATFORM,
  TRIAL_OPTIONS,
  ONBOARD_KICKSTART,
  ONBOARD_PLATFORM,
  MESSAGE_PAYMENT_METHOD_SUCCESS,
  MESSAGE_PAYMENT_METHOD_PROCESSING,
  MESSAGE_PAYMENT_METHOD_FAILED,
  MESSAGE_PAYMENT_METHOD_INVALID_REQUEST,
  MESSAGE_PAYMENT_METHOD_ALREADY_MEMBER,
  STATUS_PAYMENT_METHOD_SUCCEEDED,
  STATUS_PAYMENT_METHOD_PROCESSING,
  LINEAR_ID_MAP,
  BILLING_CYCLE_MONTHLY,
  BILLING_CYCLE_YEARLY,
  MEMBERSHIP_OPTION_PLATFORM,
  MEMBERSHIP_OPTION_NAVIGATOR,
  MEMBERSHIP_PLANS,
  COUPON_BILLING_PERIOD_BOTH,
  LABEL_DUE_TODAY,
  PAYMENT_STEP_PLAN,
  PAYMENT_STEP_PAYMENT,
  TRIAL_VARIANT
}
